import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsFetching } from '../selectors';
import { fetchPpisRelatedToFormulaCode } from '../actions';

const usePpisRelatedToFormulaCode = formulaCode => {
  const [notStartedFetching, setNotStartedFetching] = useState(true);
  const dispatch = useDispatch();
  const isFetchingPpis = useSelector(getIsFetching);
  const isFetching = notStartedFetching ? true : isFetchingPpis;

  useEffect(() => {
    dispatch(fetchPpisRelatedToFormulaCode(formulaCode));
    setNotStartedFetching(false);
  }, [dispatch, formulaCode]);

  return [isFetching];
};

export default usePpisRelatedToFormulaCode;
